import { render } from "./ProductEdit.vue?vue&type=template&id=071f3a8a&scoped=true&ts=true"
import script from "./ProductEdit.vue?vue&type=script&lang=ts"
export * from "./ProductEdit.vue?vue&type=script&lang=ts"

import "./ProductEdit.vue?vue&type=style&index=0&id=071f3a8a&lang=stylus"
import "./ProductEdit.vue?vue&type=style&index=1&id=071f3a8a&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071f3a8a"]])

export default __exports__